import { render, staticRenderFns } from "./WorksMatchingWorksList.vue?vue&type=template&id=bce52160&"
import script from "./WorksMatchingWorksList.vue?vue&type=script&lang=js&"
export * from "./WorksMatchingWorksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports